import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

import NavbarHome from "../../../components/ui/NavbarHome";
import { LoaderIcon } from "../../../components/ui/Swicons";
import { devURL, mailformat } from "../../../utils";
// import Api from "../../../Api";
import { login } from "../../../Api/index";
import GoogleOAuth from "../Google/GoogleOAuth";
import { sendAnalyticsEvent } from "../../../analytics";

const axios = require("axios");

export default function Login({ carry }) {
  const { register, handleSubmit } = useForm();
  const [loader, isLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isDisabledLogin, setDisabledLogin] = useState(true);
  const initialValues = { username: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [showPassword, setShowPassword] = useState(false);
  carry(location.state);
  useEffect(() => {
    if (
      localStorage.getItem("swToken") &&
      localStorage.getItem("swToken") != ""
    ) {
      navigate("/Add-Transaction");
    }
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "username" && e.target.value.length >= 0) {
      formValues.username = e.target.value;
    } else if (e.target.name === "password" && e.target.value.length >= 0) {
      formValues.password = e.target.value;
    }
    if (formValues.username !== "" && formValues.password !== "")
      setDisabledLogin(false);
    else setDisabledLogin(true);
  };

  const onSubmit = (val) => {
    if (val.username === "") {
      toast.error("Please enter your email address!.");
      isLoading(false);
    } else if (!val.username.match(mailformat)) {
      toast.error("You have entered an invalid email address!.");
      isLoading(false);
    } else if (val.password === "") {
      toast.error("Please enter your password.");
      isLoading(false);
    } else {
      isLoading(true);
      axios
        .post(`${devURL}/user/login`, {
          username: val.username.toLowerCase(),
          password: val.password,
        })
        .then((res) => {
          axios
            .get(`${devURL}/user/get-user-info`, {
              headers: { token: res.data.token },
            })
            .then((users) => {
              if (users.data.full_name) {
                localStorage.setItem("SXUser", users.data.full_name);
              }
            })
            .catch((err) => {
              console.log(err);
            });
          isLoading(false);
          login(val.username.toLowerCase());
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Welcome!",
            showConfirmButton: false,
            timer: 1500,
          });
          //toast.success("You have successfully login!");
          localStorage.setItem("swToken", res.data.token);
          sendAnalyticsEvent("login", {
            category: "user",
            action: "login",
            label: "user_login",
          });
          if (res.data.token) navigate("/Dashboard");
        })
        .catch((err) => {
          isLoading(false);
          if (
            err.response &&
            err.response.data &&
            err.response.data.errorMessage
          ) {
            toast.error(err.response.data.errorMessage);
          }
        });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <NavbarHome />
        <div className="min-h-full font-nunito mt-24 lg:mt-8relative flex items-center justify-center sm:mt-24 sm:px-6 lg:px-8">
          <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
            <div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                Welcome back
              </h2>
            </div>
            <input type="hidden" name="remember" value="true" />
            <div className=" space-y-4">
              <div>
                <label htmlFor="username" className="font-light">
                  Your email address<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  {...register("username")}
                  name="username"
                  onInput={handleChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSubmit(onSubmit)();
                    }
                  }}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Your email address"
                />
              </div>
              <div>
                <label htmlFor="password" className="font-light">
                  Your password<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative flex items-center">
                  <input
                    {...register("password")}
                    name="password"
                    autoComplete="current-password"
                    type={showPassword ? "text" : "password"}
                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                    placeholder="Your password"
                    onInput={handleChange}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                      }
                    }}
                  ></input>
                  <button
                    className="absolute left-full -translate-x-full p-2 z-20"
                    data-test="show-password"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPassword((val) => !val);
                    }}
                  >
                    {!showPassword ? (
                      <AiOutlineEye size="1.2rem" />
                    ) : (
                      <AiOutlineEyeInvisible size="1.2rem" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 block text-sm text-gray-900"
                >
                  {" "}
                  Remember me{" "}
                </label>
              </div>

              <div className="text-md">
                <Link
                  to="/forgot-password"
                  className="font-semibold"
                  style={{ color: "#246eaa" }}
                >
                  {" "}
                  <u>Forgot your password?</u>{" "}
                </Link>
              </div>
            </div>

            <div className="mb-28 flex flex-col gap-4">
              <button
                type="submit"
                className="group relative w-full text-md  font-semibold flex justify-center py-2 px-4 border border-transparent rounded-md text-white bg-themeColor hover:bg-bg-themeHover"
                style={
                  !isDisabledLogin
                    ? { backgroundColor: "#246eaa" }
                    : { backgroundColor: "#246eaa", opacity: "50%" }
                }
                disabled={isDisabledLogin}
              >
                {loader && <LoaderIcon />}
                {!loader && <>Login</>}
              </button>
              <div className="self-center font-bold">or</div>
              <GoogleOAuth />
            </div>
            <div className="text-center border-t-2 border-solid border-gray-300 ">
              <div className="mt-4 text-lg">
                New to Scopex?{" "}
                <span style={{ color: "#246eaa" }}>
                  {" "}
                  <Link to="/SignUp" className="font-extrabold ml-1 text-md">
                    <u>Sign up</u>
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
